import React from "react";
import lodash from "lodash";
import PATHS from "config/paths";

/* eslint-disable react-hooks/exhaustive-deps */

export function useDeleteContact(token, requestContact, isConfirmed) {
  const [response, setResponse] = React.useState();
  const [error, setError] = React.useState();
  const [isLoading, setIsLoading] = React.useState(false);
  const [contact, setContact] = React.useState();


  /**
   * Compare requestBody to contact so we don't infinite loop
   */
  React.useEffect(() => {
    if (!lodash.isEqual(requestContact, contact) &&  isConfirmed) {
      setError(undefined);
      setResponse(undefined);
      setContact(requestContact);
      setIsLoading(true);
    }
  }, [requestContact, setContact,  isConfirmed]);

  /**
   * Make Request
   */
  React.useEffect(() => {
    if (token && contact ) {
      const options = {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        }
      };

      const path = `${PATHS.apiContacts}/${contact.id}`;

      async function postRequest() {
        const request = await fetch(path, options);
        return true;
      }

      // Delete returns 204 No Content so it does not have a body, setResponse to true
      postRequest()
        .then(async (response) => {      
           setResponse(response)
          })
          .catch((err) => {
            setError(err);
          })
          .finally(() => {
            setIsLoading(false);
          });
    }
  }, [token, contact, setResponse]);

  return { contactDeleteSuccess: response, contactDeleteError: error, contactIsLoading: isLoading };
}
